<template>
  <div class="general-data">
    <el-row>
      <el-col class="general-header">
        <h1>Datos generales</h1>
        <div class="icons-data">
          <router-link
            :to="{name: 'editProfile'}">
            <i class="icon-edit-icon"/>
          </router-link>
        </div>
      </el-col>
    </el-row>
    <br><br>
    <el-row>
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="col-general-data">
        <label>Usuario</label><br>
        <span>{{ user.userName }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="col-general-data">
        <label>Nombre</label><br>
        <span>{{ user.name_user }}</span>
      </el-col>
      <el-col
        :span="24"
        class="col-general-data">
        <label>Mail</label><br>
        <span>{{ user.email }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="col-general-data">
        <label>Fecha de nacimiento</label><br>
        <span>{{ user.datebirth }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="col-general-data">
        <label>Sexo</label><br>
        <span>{{ user.genre }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="col-general-data">
        <label>Miembro desde</label><br>
        <span>{{ user.createdAt }}</span>
      </el-col>
      <el-col
        :span="24">
        <el-checkbox class="check-mt">Dejar de recibir noticias</el-checkbox>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'GeneralData',
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  }
}
</script>

<style lang="scss" scoped>

  .general-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E3E6EA;
    padding-bottom: 15px;
    h1{
      margin: 0;
      @include font-primary(14px, semibold)
    }
    .icons-data{
      cursor: pointer;

      i{
        color: #444444 !important;

      }
    }
  }
  a{
    text-decoration: none;
    margin-left: 30px;
  }

  .cancel-account {
    border-top: 1px solid #E3E6EA;
    margin-top: 20px;
    display: flex;
    align-items: center;
    button {
      @include font-primary(12px, semibold);
      color: #444444;
      text-decoration: underline;
      margin: 0 auto;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/user-profile/general-data.vue